import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overlay-wrapper" }
const _hoisted_2 = { class: "row gy-1 g-xl-12 mb-2" }
const _hoisted_3 = { class: "col-sm-3" }
const _hoisted_4 = {
  class: "card",
  style: {"background-color":"grey"}
}
const _hoisted_5 = { class: "card-body d-flex flex-column p-5" }
const _hoisted_6 = { class: "flex-grow-1 card-p pb-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-white text-hover-primary fw-bolder fs-3" }, " Supplier ", -1)
const _hoisted_8 = { class: "text-white fs-8 fw-bold" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-white text-hover-primary fw-bolder fs-3" }, " Account Manager ", -1)
const _hoisted_10 = { class: "text-white fs-8 fw-bold" }
const _hoisted_11 = { class: "col-sm-9" }
const _hoisted_12 = { class: "row gy-5" }
const _hoisted_13 = { class: "col-xl-6" }
const _hoisted_14 = {
  class: "card",
  style: {"background-color":"rgb(36, 70, 86)"}
}
const _hoisted_15 = { class: "card-body d-flex flex-column p-5" }
const _hoisted_16 = { class: "flex-grow-1 card-p pb-0" }
const _hoisted_17 = { class: "d-flex flex-stack flex-wrap" }
const _hoisted_18 = { class: "me-2" }
const _hoisted_19 = { class: "row gy-1 g-xl-12" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-xl-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/flex/pound-green.jpg",
    class: "h-50px"
  })
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-xl-4 text-white fw-bolder fs-4" }, " Position Summary ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-white fw-bolder mb-3" }, " Budget Cost "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-white fw-bolder mb-3" }, " Market Cost "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-white fw-bolder mb-3" }, " MTM Cost ")
], -1)
const _hoisted_23 = { class: "col-xl-3" }
const _hoisted_24 = { class: "text-white fw-bolder mb-3" }
const _hoisted_25 = { class: "text-white fw-bolder mb-3" }
const _hoisted_26 = { class: "text-white fw-bolder mb-3" }
const _hoisted_27 = { class: "col-xl-6" }
const _hoisted_28 = {
  class: "card",
  style: {"background-color":"rgb(36, 70, 86)"}
}
const _hoisted_29 = { class: "card-body d-flex flex-column p-5" }
const _hoisted_30 = { class: "flex-grow-1 card-p pb-0" }
const _hoisted_31 = { class: "row gy-1 g-xl-12" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-xl-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/flex/performance.jpg",
    class: "h-50px"
  })
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "col-xl-4 text-white fw-bolder fs-4" }, " Performance Summary ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-white fw-bolder mb-3" }, "Baseline:"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-white fw-bolder mb-3" }, "Budget:"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-white fw-bolder mb-3" }, "MTM:")
], -1)
const _hoisted_35 = { class: "col-xl-3" }
const _hoisted_36 = { class: "text-white fw-bolder mb-3" }
const _hoisted_37 = { class: "text-white fw-bolder mb-3" }
const _hoisted_38 = { class: "text-white fw-bolder mb-3" }
const _hoisted_39 = { class: "row gy-1 g-xl-12 mb-2" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3" }, null, -1)
const _hoisted_41 = { class: "col-sm-9" }
const _hoisted_42 = { class: "row gy-5" }
const _hoisted_43 = { class: "col-xl-6" }
const _hoisted_44 = {
  class: "card",
  style: {"background-color":"rgb(203, 103, 105)"}
}
const _hoisted_45 = { class: "card-body d-flex flex-column p-5" }
const _hoisted_46 = { class: "flex-grow-1 card-p pb-0" }
const _hoisted_47 = { class: "me-2" }
const _hoisted_48 = { class: "row gy-1 g-xl-12" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/flex/battery.jpg",
    class: "h-50px"
  })
], -1)
const _hoisted_50 = { class: "col-xl-8" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "text-white fw-bolder fs-4" }, " Open Volume ", -1)
const _hoisted_52 = { class: "fw-bolder text-white fs-1" }
const _hoisted_53 = { class: "col-xl-6" }
const _hoisted_54 = {
  class: "card",
  style: {"background-color":"rgb(53, 164, 117)"}
}
const _hoisted_55 = { class: "card-body d-flex flex-column p-5" }
const _hoisted_56 = { class: "flex-grow-1 card-p pb-0" }
const _hoisted_57 = { class: "me-2" }
const _hoisted_58 = { class: "row gy-1 g-xl-12" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/flex/pound-lightgreen.jpg",
    class: "h-50px"
  })
], -1)
const _hoisted_60 = { class: "col-xl-8" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "text-white fw-bolder fs-4" }, " Savings vs Budget ", -1)
const _hoisted_62 = { class: "fw-bolder text-white fs-1" }
const _hoisted_63 = { class: "row gy-5 g-xl-12 mb-2" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3" }, null, -1)
const _hoisted_65 = { class: "col-sm-9" }
const _hoisted_66 = { class: "row gy-5" }
const _hoisted_67 = { class: "col-xl-6" }
const _hoisted_68 = {
  class: "card",
  style: {"background-color":"rgb(203, 103, 105)"}
}
const _hoisted_69 = { class: "card-body d-flex flex-column p-5" }
const _hoisted_70 = { class: "flex-grow-1 card-p pb-0" }
const _hoisted_71 = { class: "me-2" }
const _hoisted_72 = { class: "row gy-1 g-xl-12" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/flex/battery.jpg",
    class: "h-50px"
  })
], -1)
const _hoisted_74 = { class: "col-xl-8" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "text-white fw-bolder fs-4" }, " Closed Volume ", -1)
const _hoisted_76 = { class: "fw-bolder text-white fs-1" }
const _hoisted_77 = { class: "col-xl-6" }
const _hoisted_78 = {
  class: "card",
  style: {"background-color":"rgb(53, 164, 117)"}
}
const _hoisted_79 = { class: "card-body d-flex flex-column p-5" }
const _hoisted_80 = { class: "flex-grow-1 card-p pb-0" }
const _hoisted_81 = { class: "me-2" }
const _hoisted_82 = { class: "row gy-1 g-xl-12" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/flex/pound-lightgreen.jpg",
    class: "h-50px"
  })
], -1)
const _hoisted_84 = { class: "col-xl-8" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "text-white fw-bolder fs-4" }, " Locked Savings ", -1)
const _hoisted_86 = { class: "fw-bolder text-white fs-1" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer bg-dark-o-25" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner spinner-primary" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'overlay overlay-block': _ctx.loading })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.dashboard.Supplier), 1),
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.dashboard.AccountManager), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_router_link, { to: "/FlexibleProcurement/PositionSummary" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _hoisted_21,
                              _hoisted_22,
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$filters.StringFormat(_ctx.dashboard.budget_cost)), 1),
                                _createElementVNode("div", _hoisted_25, " £" + _toDisplayString(_ctx.$filters.StringFormat(_ctx.dashboard.market)), 1),
                                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$filters.StringFormat(_ctx.dashboard.mtm_cost)), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_router_link, { to: "/FlexibleProcurement/PerformanceSummary" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _hoisted_33,
                          _hoisted_34,
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$filters.StringFormat(_ctx.dashboard.baseline)), 1),
                            _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$filters.StringFormat(_ctx.dashboard.budget)), 1),
                            _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$filters.StringFormat(_ctx.dashboard.mtm)), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _hoisted_40,
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_router_link, { to: "/FlexibleProcurement/OpenVolume" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _hoisted_49,
                            _createElementVNode("div", _hoisted_50, [
                              _hoisted_51,
                              _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$filters.StringFormat(_ctx.dashboard.Floating)) + "MWh (" + _toDisplayString(_ctx.$filters.StringFormat(
                                  _ctx.dashboard.FloatingPercent
                                )) + "%) ", 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createVNode(_component_router_link, { to: "/FlexibleProcurement/SavingsVsBudget" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("div", _hoisted_58, [
                            _hoisted_59,
                            _createElementVNode("div", _hoisted_60, [
                              _hoisted_61,
                              _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$filters.StringFormat(_ctx.dashboard.savings_budget)), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_63, [
        _hoisted_64,
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("div", _hoisted_68, [
                _createVNode(_component_router_link, { to: "/FlexibleProcurement/OpenVolume" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, [
                            _hoisted_73,
                            _createElementVNode("div", _hoisted_74, [
                              _hoisted_75,
                              _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.$filters.StringFormat(_ctx.dashboard.Fixed)) + "MWh (" + _toDisplayString(_ctx.$filters.StringFormat(_ctx.dashboard.FixedPercent)) + "%) ", 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _hoisted_83,
                        _createElementVNode("div", _hoisted_84, [
                          _hoisted_85,
                          _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.$filters.StringFormat(_ctx.dashboard.lockedSavings)), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_87
  ], 2))
}